// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".articles[data-v-2e1035a9]{display:grid;grid-template-columns:subgrid;gap:16px;grid-column:1/-1}", ""]);
// Exports
module.exports = exports;
